import axios from "axios";
import { useEffect, useState, useCallback } from "react";
import AppConfig from './AppConfig.json'
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router";
import * as actions from './actions'
import { validate } from 'jsonschema';
import ErrorMessage from "./ErrorMessage";

export function MemberEditAddress({ app, onUpdate }) {
    const { currentUserProfile } = app
    const history = useHistory()
    const [address, setAddress] = useState({
        homeNo: "",
        villageOrBuilding: "",
        moo: "",
        soi: "",
        road: "",
        typeOfHousing: "",
        country: "",
        city: "",
        district: "",
        subdistrict: "",
        postalCode: ""
    })
    const [resident, setResident] = useState([])
    const [province, setProvince] = useState([])
    const [district, setDistrict] = useState([])
    const [subDistrict, setSubDistrict] = useState([])
    const [errorMessage, setErrorMessage] = useState(null)

    const loadMasterData = useCallback(async (options) => {
        let result = await axios.post(`${AppConfig.endpoint}/member/master`, options, {
            headers: {
                "x-access-token": app.accessToken,
                "x-api-key": AppConfig.api_key
            }
        })

        let items = result.data.map(item => item)
        return items
    }, [app.accessToken]);

    const loadDistrict = useCallback(async (province) => {
        const data = await loadMasterData({
            lov_type: "CRC_DISTRICT",
            parent_sub_type: "CRC_CITY",
            sub_type: province,
        })
        setDistrict(data)
        return data
    }, [loadMasterData]);

    const loadSubDistrict = useCallback(async (district) => {
        const data = await loadMasterData({
            lov_type: "CRC_SUB_DISTRICT",
            parent_sub_type: "CRC_DISTRICT",
            sub_type: district,
        })
        setSubDistrict(data)
        return data
    }, [loadMasterData]);

    useEffect(() => {
        const fetchProvinceData = async () => {
          try {
            const result = await loadMasterData({
              lov_type: "CRC_CITY"
            });
            setProvince(result);
          } catch (error) {
            console.error('Error loading provinces data:', error);
          }
        };

        const fetchResidentData = async () => {
          try {
            const result = await loadMasterData({
                lov_type: "CRC_HOUSE_TYPE",
            });
            setResident(result);
          } catch (error) {
                console.error('Error loading residents data:', error);
          }
        }
      
        fetchProvinceData();
        fetchResidentData();
      }, [loadMasterData]);
      
      useEffect(() => {
        const handleAddressData = async () => {
            if (currentUserProfile) {
                let districts = []
                if (currentUserProfile.addresses && currentUserProfile.addresses.length > 0) {
                    const [ address ] = currentUserProfile.addresses;                    
                    if (address.city) {
                        let p = province.filter(x => x.value === address.city)[0]
                        if(p) {
                            districts = await loadDistrict(p.name)
                        }
                    }
                    else if (!address.city && province.length > 0) {
                        districts = await loadDistrict(province[0].value)
                    }

                    if (address.district) {
                        let p = districts.filter(x => x.value === address.district)[0]
                        if(p) {
                            await loadSubDistrict(p.name)
                        }
                    }
                    else if (!address.district && districts.length > 0) {
                        await loadSubDistrict(districts[0].value)
                    }
                    
                    setAddress(address)
                }
            }
        };
      
        handleAddressData();
      }, [province, resident, loadDistrict, loadSubDistrict, currentUserProfile]);

    const formValidate = () => {
        var schema = {
            "type": "object",

            "properties": {
                homeNo: { "type": "string", minLength: 1 },
                villageOrBuilding: { "type": "string" },
                moo: { "type": "string" },
                soi: { "type": "string" },
                road: { "type": "string" },
                typeOfHousing: { "type": "string", minLength: 1 },
                // country: { "type": "string", minLength: 2 },
                city: { "type": "string", minLength: 1 },
                district: { "type": "string", minLength: 1 },
                subdistrict: { "type": "string", minLength: 1 },
                postalCode: { "type": "string", minLength: 1 }
            },
            required: ["homeNo", "road", "typeOfHousing", "city", "district", "subdistrict", "postalCode"]

        }

        let result = validate(address, schema)
        return result.valid
    }

    // TODO: refactor to edit profile
    const sendUpdate = async () => {

        let body = { address: [{ ...address, addressType: "Contact Address", country: "Thailand" }] }

        let result = await axios.post(`${AppConfig.endpoint}/member/update/address`, body, {
            headers: {
                "x-access-token": app.accessToken,
                "x-api-key": AppConfig.api_key
            }
        })

        if (result.data.success) {
            history.push("/member/profile")
            onUpdate && onUpdate()
        }
        else {
            setErrorMessage(result.data)
        }
    }

    const onChangeProvince = async (provinceValue) => {
        let cityItem = province.filter(x => x.value === provinceValue)[0]
        const districtArray = await loadDistrict(cityItem.name)
        const districtDefault = districtArray[0];
        await loadSubDistrict(districtDefault.name)
        setAddress({ ...address, city: cityItem.value, postalCode: ""})
    }

    const onChangeDistrict = async (districtValue) => {
        let districtItem = district.filter(x => x.value === districtValue)[0]
        await loadSubDistrict(districtItem.name)
        setAddress({ ...address, district: districtItem.value, postalCode: ""})
    }

    const onChangeSubDistrict = (subDistrictValue) => {
        let postCode = subDistrict.filter(x => x.value === subDistrictValue)
        setAddress({ ...address, subDistrict: subDistrictValue, postalCode: postCode.length > 0 ? postCode[0].high_value : "" })
    }

    return <div className="edit-screen pin-auth-screen">
        {errorMessage && <ErrorMessage title="Error" message={errorMessage} />}
        <div className="section-header">Address</div>
        <div className="edit-form">
            <div className="field">
                <label className="label">Home No. *</label>
                <div className="control">
                    <input className="input" type="text" data-testid="input-homeNo" value={address.homeNo ?? ""} onChange={(e) => {
                        setAddress({ ...address, homeNo: e.target.value })
                    }} disabled />
                </div>
            </div>

            <div className="field">
                <label className="label">Village/Building</label>
                <div className="control">
                    <input className="input" type="text" data-testid="input-village" value={address.villageOrBuilding ?? ""} onChange={(e) => {
                        setAddress({ ...address, villageOrBuilding: e.target.value })
                    }} disabled />
                </div>
            </div>

            <div className="field">
                <label className="label">Moo</label>
                <div className="control">
                    <input className="input" type="text" data-testid="input-moo" value={address.moo ?? ""} onChange={(e) => {
                        setAddress({ ...address, moo: e.target.value })
                    }} disabled />
                </div>
            </div>


            <div className="field">
                <label className="label">Soi</label>
                <div className="control">
                    <input className="input" type="text" data-testid="input-soi" value={address.soi ?? ""} onChange={(e) => {
                        setAddress({ ...address, soi: e.target.value })
                    }} disabled />
                </div>
            </div>

            <div className="field">
                <label className="label">Street</label>
                <div className="control">
                    <input className="input" type="text" data-testid="input-street" value={address.road ?? ""} onChange={(e) => {
                        setAddress({ ...address, road: e.target.value })
                    }} disabled />
                </div>
            </div>


            <div className="field">
                <label className="label">Residence Type *</label>
                <div className="control">
                    <div className="select">
                        <select data-testid="select-residence" value={address.typeOfHousing} onChange={(e) => {
                            setAddress({ ...address, typeOfHousing: e.target.value })
                        }} disabled >
                            <option value=""></option>
                            {resident.map(item => <option value={item.value} key={item.value}>{item.name}</option>)}
                        </select>
                    </div>
                </div>

            </div>

            <div className="field">
                <label className="label">Province *</label>
                <div className="control">
                    <div className="select">
                        <select data-testid="select-province" value={address.city} onInput={(e) => onChangeProvince(e.target.value)} disabled>
                            <option value=""></option>
                            {province.map(item => <option value={item.value} key={item.value}>{item.name}</option>)}
                        </select>
                    </div>
                </div>
            </div>


            <div className="field">
                <label className="label">District *</label>
                <div className="control">
                    <div className="select">
                        <select data-testid="select-district" value={address.district} onChange={(e) => onChangeDistrict(e.target.value)} disabled>
                            <option value=""></option>
                            {district && district.map(item => <option value={item.value} key={item.value}>{item.name}</option>)}
                        </select>
                    </div>
                </div>
            </div>

            <div className="field">
                <label className="label">Sub-district *</label>
                <div className="control">
                    <div className="select">
                        <select data-testid="select-subDistrict" value={address.subdistrict} onChange={(e) => onChangeSubDistrict(e.target.value)} disabled>
                            <option value=""></option>
                            {subDistrict && subDistrict.map(item => <option value={item.value} key={item.value}>{item.name}</option>)}
                        </select>
                    </div>
                </div>
            </div>

            <div className="field">
                <label className="label">Postal Code *</label>
                <div className="control">
                    <input className="input" type="text" data-testid="input-postalCode" value={address.postalCode} onChange={(e) => {
                        setAddress({ ...address, postalCode: e.target.value })
                    }} disabled />
                </div>
            </div>
        </div>

        {/* <div className="screen-footer">
            <button className="button is-fullwidth is-save" disabled={!formValidate()} data-testid="confirm-btn" onClick={() => sendUpdate()}>Continue</button>
        </div> */}
    </div>
}

export default withRouter(connect((state) => state, actions)(MemberEditAddress))